module.exports = __webpack_public_path__ + "static/media/toggle-button.68062bd0.svg";